var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteMemberIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9247 32.6023H1.54004V31.2123C1.56045 29.2579 2.07588 27.3405 3.03817 25.6394C4.00048 23.9382 5.37824 22.5087 7.04278 21.4843C8.70735 20.46 10.6044 19.8743 12.5567 19.7818C14.509 19.6894 16.4528 20.0933 18.2067 20.9558M19.4888 27.474H34.8734M13.0785 14.6535C16.6188 14.6535 19.4888 11.7835 19.4888 8.24326C19.4888 4.70298 16.6188 1.83301 13.0785 1.83301C9.53825 1.83301 6.66827 4.70298 6.66827 8.24326C6.66827 11.7835 9.53825 14.6535 13.0785 14.6535Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMemberIconSuccess);
export default __webpack_public_path__ + "static/media/deleteMemberIconSuccess.51f36fa10248f8fe19facbd5ea6cd874.svg";
export { ForwardRef as ReactComponent };